import { useCallback } from "react"

export const useDisplayCurrency = () => {
    return useCallback((param: number, locales: Intl.LocalesArgument = 'fr-FR', options?: Intl.NumberFormatOptions) => {
        return param?.toLocaleString(locales, { style: 'currency', currency: 'EUR', ...options })
    }, [])
}
